module.exports = __webpack_public_path__ + "static/mp-3680ccd9f4fdfceb4617b181855a50a6.svg";